import { useTranslation } from "react-i18next";
import CardProject from "./card.component";
const PortfolioComponent = () => {
  const { t } = useTranslation();
  const projects: any = t("projects", { returnObjects: true });
  return (
    <article
      className="portfolio active"
      style={{ paddingBottom: 55 }}
      data-page="portfolio"
    >
      <header>
        <h2 className="h2 article-title">{t(`navbar.portfolio`)}</h2>
      </header>

      <section className="projects">
        {/*<h3 className="personal-projects"> {t(`portfolio.personalProjects`)}</h3>*/}
        <ul className="project-list">
          {projects.map((project: any, index: any) => (
            <li
              className="project-item active"
              data-filter-item
              data-category="web development"
              key={index}
            >
              <CardProject index={index} />
            </li>
          ))}
          <li
            className="project-item active"
            data-filter-item
            data-category="web development"
          >
            <div className="joke-card">
              <div className="joke-icon">🚀</div>
              <h3 className="project-title joke-title">
                {t("portfolio.joke.title")}
              </h3>
              <p className="project-category joke-desc">
                {t("portfolio.joke.desc")}
              </p>
            </div>
          </li>
        </ul>
      </section>
      {/*
            <section className="projects">
      <h3 className="personal-projects"> {t(`portfolio.professionalProjects`)}</h3>
        <ul className="project-list">
          {works.map((index: any) => (
            <li
            className="project-item active"
              data-filter-item
              data-category="web development"
              key={index}
              >
              <WorkProject index={index} />
            </li>
          ))}
        </ul>
      </section>
      */}
    </article>
  );
};
export default PortfolioComponent;
